import { useQuery } from '@tanstack/react-query';
import { searchGroupFlightOffers } from './api';
import type { GroupFlightOffersQuery, GroupFlightOffersView } from './types';

/** Query key of one group's picker search — invalidated when a pick finds its offer lapsed. */
export function groupFlightOffersKey(groupId: string, query?: GroupFlightOffersQuery): unknown[] {
  return query ? ['rebooking', 'flight-offers', groupId, query] : ['rebooking', 'flight-offers', groupId];
}

/**
 * The manual picker's provider offers for ONE PNR group. Re-runs when the committed
 * query changes (the operator hits Search, or changes the cabin). Offers lapse — the
 * provider's own expiry — so a result is fresh for a minute only, and never retried
 * blindly: a provider chain that answered nothing is an answer, not a blip.
 */
export function useGroupFlightOffers(
  groupId: string,
  caseUrn: string | undefined,
  query: GroupFlightOffersQuery,
  enabled = true,
) {
  return useQuery<GroupFlightOffersView>({
    queryKey: groupFlightOffersKey(groupId, query),
    queryFn: () => searchGroupFlightOffers(groupId, query, caseUrn),
    enabled: enabled && !!groupId,
    staleTime: 60_000,
    retry: false,
  });
}
